module.exports = __webpack_public_path__ + "static/img/20190221021607_744510.0c573558.jpg";